/**
 * LOADER_TRACKER.JSX - Composant de tracking du chargement
 * 
 * Ce composant DOIT être placé à l'intérieur du Canvas pour accéder
 * à useProgress de Drei. Il communique la progression au parent via callback.
 * 
 * UTILISATION:
 * <Canvas>
 *   <LoaderTracker onProgress={(progress) => console.log(progress)} />
 *   <Scene />
 * </Canvas>
 */

import { useProgress } from '@react-three/drei'
import { useEffect } from 'react'

/**
 * LoaderTracker Component
 * 
 * @param {Function} onProgress - Callback appelé avec la progression (0-100)
 * @returns {null} Ne rend rien à l'écran
 */
export function LoaderTracker({ onProgress }) {
  const { progress } = useProgress()
  
  useEffect(() => {
    if (onProgress) {
      onProgress(progress)
    }
  }, [progress, onProgress])
  
  return null // Ne rend rien visuellement
}

